import React from 'react';

// Import images
import b2bProducts1 from "../assets/img/Products/b2b_Products-1.png";
import b2bProductFeature2 from "../assets/img/Products/b2b-Product-feature-2.png";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';

const B2CProduct = () => {
  return (
    <div>
      <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Products</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
            <li className="breadcrumb-item"><a href="#">E-Commerce</a></li>
            <li className="breadcrumb-item active text-primary">B2C Products</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bProducts1}
                    className="img-fluid rounded w-100"
                    alt="B2b Products-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 p-5">
              <h1>Effortless Ordering & Transparency for Business Vendors</h1>
              <p className="font-size-p">
                Managing inventory and ordering stock for businesses has never been easier! Our B2B mobile application empowers business vendors, purchase managers, store owners, and distributors by providing a seamless end-to-end procurement workflow. Designed to enhance transparency, efficiency, and control, our solution ensures a hassle-free ordering experience while reducing manual errors and delays.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-light p-30">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-7 col-lg-7 p-5">
              <h1>Key Features & Benefits</h1>
              <div className="pt-5">
                <ul className="list-unstyled">
                  <li><span className="icon-box"></span> Simplified Purchase Management</li>
                  <li><span className="icon-box"></span> Purchase Managers can easily browse products, place orders, and track status in real-time.</li>
                  <li><span className="icon-box"></span> Smart Reordering based on demand forecasts and stock levels.</li>
                  <li><span className="icon-box"></span> Customizable Approval Workflows for seamless order authorization.</li>
                  <li><span className="icon-box"></span> Store Owners receive instant notifications for order approvals.</li>
                  <li><span className="icon-box"></span> One-click approval or modifications for better control over purchases.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5 col-lg-5 p-30">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bProductFeature2}
                    className="img-fluid rounded w-100"
                    alt="B2b Products-1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bProductFeature2}
                    className="img-fluid rounded w-100"
                    alt="B2b Products-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 p-5">
              <h1>Seamless Integrations & Smart Features</h1>
              <div className="pt-5">
                <ul className="list-unstyled">
                  <li><span className="icon-box"></span> Mobile App Accessibility – Order and track on the go from Android & iOS.</li>
                  <li><span className="icon-box"></span> AI-Powered Order Recommendations – Helps purchase managers make data-driven decisions.</li>
                  <li><span className="icon-box"></span> Secure Payment Gateway Integration – Supports UPI, Net Banking, Credit/Debit Cards, and BNPL.</li>
                  <li><span className="icon-box"></span> Multi-Level User Access – Role-based permissions for store owners, managers, and distributors.</li>
                  <li><span className="icon-box"></span> Store Owners receive instant notifications for order approvals.</li>
                  <li><span className="icon-box"></span> Real-Time Alerts & Notifications – Keep all stakeholders updated instantly.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}
      <Footer/>
    </div>
  );
};

export default B2CProduct;